// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-1iRt7895","stock_box":"stock_box-2qFE-fN4"};